import { eventBus } from '@spon/plugins';

function FadeIn({ node }) {
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (
          entry.isIntersecting &&
          !entry.target.classList.contains('has-moved')
        ) {
          entry.target.classList.add('has-moved');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -40% 0px' }
  );

  function observe() {
    node.querySelectorAll('[data-fade-in]:not(.has-moved)').forEach(el => {
      observer.observe(el);
    });
  }

  observe();

  eventBus.on('fadeIn:refresh', observe);

  return () => {
    observer.disconnect();
    eventBus.off('fadeIn:refresh', observe);
  };
}

export default FadeIn;
